"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.randomHex = void 0;
const crypto_1 = require("crypto");
exports.randomHex = (length) => crypto_1.randomBytes(Math.ceil(length / 2))
    .toString("hex")
    .slice(0, length);
//# sourceMappingURL=random-hex.js.map